import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import FormsyForm from 'formsy-react'
import PropTypes from 'prop-types'
import _partial from 'lodash/partial'
import _get from 'lodash/get'
import { historyRedirect } from '../../services/navigation/index'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../Page/connect'
import { connect as connectStaticText } from '../StaticText/connect'
import { getBoundActions } from '../../actions/index'
import { TextInput } from '../FormInput.v2/index'
import {
  getRemoteLoginCodeValidation,
  TEXTBOX_REMOTE_LOGIN_CODE,
  REMOTE_LOGIN_CODE_SUCCESSFULLY_ACTIVATED,
  APPROVE_REMOTE_LOGIN_CODE_PROCESSING,
  APPROVE_REMOTE_LOGIN_CODE_ERROR_CODE,
} from '../../services/remote-login-code/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import Sherpa, { TYPE_SMALL_WHITE } from '../Sherpa/index'
import { URL_LOGOUT } from '../../services/url/constants'
import Button, { TYPES } from '../Button/index'
import { H1 } from '../Heading/index'
import { getUserName } from '../../services/user/index'

function renderDescription (props, setIsAuthenticationConfirmed) {
  const {
    staticText, auth, remoteLoginCode, setOverlayDialogVisible,
  } = props
  const successfullyActivatedCode = remoteLoginCode.getIn(['data', REMOTE_LOGIN_CODE_SUCCESSFULLY_ACTIVATED])
  if (successfullyActivatedCode) {
    return null
  }
  if (!getAuthIsLoggedIn(auth)) {
    return (
      <FormsyForm
        className="activate-remote-login-code__form"
        key="activate-remote-login-code-form-not-authenticated"
      >
        <p key="activate-remote-login-code-description">
          { staticText.getIn(['data', 'mainDescriptionNotAuthenticated']) }
        </p>
        <div className="activate-remote-login-code__buttons">
          <Button
            type={TYPES.PRIMARY}
            onClick={function _confirmAuth () {
              setOverlayDialogVisible(TYPE_LOGIN)
              setIsAuthenticationConfirmed(true)
            }}
          >
            {staticText.getIn(['data', 'login'])}
          </Button>
        </div>
      </FormsyForm>
    )
  }
  return null
}

function logout (props) {
  const { history, auth, user } = props
  const language = user.getIn(['data', 'language', 0], 'en')
  historyRedirect({
    query: { redirect: 'activate' },
    url: URL_LOGOUT,
    language,
    history,
    auth,
  })
}

function renderAuth (props, state, successfullyActivatedCode, setIsAuthenticationConfirmed) {
  const { staticText, auth, user } = props
  const { isAuthenticationConfirmed } = state

  if (successfullyActivatedCode) {
    return null
  }
  if (!getAuthIsLoggedIn(auth)) {
    return null
  }
  if (isAuthenticationConfirmed) {
    return null
  }

  const displayName = `${user.getIn(['data', 'firstName'], '') || ''} ${user.getIn(['data', 'lastName'], '') || ''}`
  const userName = displayName === ' ' ? getUserName(user.get('data')) : displayName

  return (
    <FormsyForm
      className="activate-remote-login-code__form"
      key="activate-remote-login-code-form"
    >
      <p key="activate-remote-login-code-auth-label" className={'activate-remote-login-code__label'}>
        { staticText.getIn(['data', 'youAreLoggedInAs']) }
        <span key="activate-remote-login-code-username" className="activate-remote-login-code__username">
          {userName}
        </span>
      </p>
      <div className="activate-remote-login-code__buttons">
        <Button
          type={TYPES.PRIMARY}
          onClick={function _confirmAuth () { setIsAuthenticationConfirmed(true) }}
        >
          {staticText.getIn(['data', 'activateCode'])}
        </Button>
        <Button
          type={TYPES.SECONDARY}
          onClick={function _logout () { logout(props) }}
        >
          {staticText.getIn(['data', 'loginAsADifferentUser'])}
        </Button>
      </div>
    </FormsyForm>
  )
}

function renderSuccessMessage (props) {
  const { staticText } = props
  return (<p key="activate-remote-login-code-success-label">
    { staticText.getIn(['data', 'success']) }
  </p>)
}

function renderActivationErrorMessage (props) {
  const { remoteLoginCode, staticText } = props
  const activationErrorCode = remoteLoginCode.getIn(['data', APPROVE_REMOTE_LOGIN_CODE_ERROR_CODE])
  if (activationErrorCode) {
    const activationErrorMessage = activationErrorCode === 400 ? staticText.getIn(['data', 'activationCodeErrorNotFound']) : staticText.getIn(['data', 'activationCodeErrorGeneric'])
    return (<p key="activate-remote-login-code-error" className={'activate-remote-login-code__error'}>
      {activationErrorMessage}
    </p>)
  }
  return null
}

function renderRemoteLoginControl (props) {
  const { staticText } = props
  return (<div className={'activate-remote-login-code__code'}>
    <label className={'activate-remote-login-code__label'} htmlFor={TEXTBOX_REMOTE_LOGIN_CODE}>
      { staticText.getIn(['data', 'activationCodeLabel']) }
    </label>
    <div className={'activate-remote-login-code__spacer'} />
    {renderActivationErrorMessage(props)}

    <TextInput
      name={TEXTBOX_REMOTE_LOGIN_CODE}
      maxLength={6}
      validations={getRemoteLoginCodeValidation()}
      validationErrors={{
        matchRegexp: staticText.getIn(['data', 'numOnly']),
      }}
      required
      label={staticText.getIn([
        'data',
        'enterActivationCode',
      ])}
    />
  </div>)
}

function onValidSubmit (model, props) {
  const remoteLoginCode = model[TEXTBOX_REMOTE_LOGIN_CODE]
  const { auth, getRemoteLoginCodeApproval } = props
  getRemoteLoginCodeApproval({ auth, remoteLoginCode }).then(() => {})
}

function renderForm (props, state, setIsRemoteLoginCodeInputValid) {
  const { isRemoteLoginCodeInputValid, isAuthenticationConfirmed } = state
  const { staticText, auth, remoteLoginCode } = props
  const processing = remoteLoginCode.getIn([APPROVE_REMOTE_LOGIN_CODE_PROCESSING])

  if (getAuthIsLoggedIn(auth) && isAuthenticationConfirmed) {
    return (<FormsyForm
      key="activate-remote-login-code-main-form"
      className="activate-remote-login-code__form"
      onValidSubmit={_partial(onValidSubmit, _partial.placeholder, props)}
      onValid={_partial(setIsRemoteLoginCodeInputValid, true)}
      onInvalid={_partial(setIsRemoteLoginCodeInputValid, false)}
    >
      {renderRemoteLoginControl(props)}
      <div className="activate-remote-login-code__buttons">
        <Button
          submit
          className="activate-remote-login-code__button-activate"
          type={TYPES.PRIMARY}
          disabled={!isRemoteLoginCodeInputValid || processing}

        >
          {staticText.getIn(['data', 'activate'])}
        </Button>
      </div>
    </FormsyForm>)
  }
  return null
}

function renderContent (
  props,
  state,
  setIsAuthenticationConfirmed,
  setIsRemoteLoginCodeInputValid,
) {
  const { remoteLoginCode } = props
  const successfullyActivatedCode = remoteLoginCode.getIn(['data', REMOTE_LOGIN_CODE_SUCCESSFULLY_ACTIVATED])
  const processing = remoteLoginCode.getIn([APPROVE_REMOTE_LOGIN_CODE_PROCESSING])

  if (processing) {
    return (
      <Sherpa type={TYPE_SMALL_WHITE} className={['activate-remote-login-code__sherpa']} />
    )
  }
  const returnValue = []
  returnValue.push(renderDescription(props, setIsAuthenticationConfirmed))
  returnValue.push(
    renderAuth(props, state, successfullyActivatedCode, setIsAuthenticationConfirmed),
  )
  if (successfullyActivatedCode) {
    returnValue.push(renderSuccessMessage(props))
  } else {
    returnValue.push(renderForm(props, state, setIsRemoteLoginCodeInputValid))
  }
  return returnValue
}

class ActivateRemoteLoginCodePage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isRemoteLoginCodeInputValid: false,
      isAuthenticationConfirmed: false,
    }
  }

  componentDidMount () {
    const { props } = this
    const { auth, setOverlayDialogVisible, location } = props
    const { query } = location
    const redirectedFrom = _get(query, 'redirectedFrom')

    if (!getAuthIsLoggedIn(auth) && redirectedFrom) {
      setOverlayDialogVisible(TYPE_LOGIN)
      this.setIsAuthenticationConfirmed(true)
    }
  }

  setIsRemoteLoginCodeInputValid = (isRemoteLoginCodeInputValid) => {
    this.setState(() => ({ isRemoteLoginCodeInputValid }))
  }

  setIsAuthenticationConfirmed = (isAuthenticationConfirmed) => {
    this.setState(() => ({ isAuthenticationConfirmed }))
  }

  render () {
    const { props } = this
    const {
      resolver,
      getRemoteLoginCodeApproval,
      remoteLoginCode,
      auth,
    } = props
    const codeFromQuerystring = resolver.getIn(['query', 'code'], null)
    const activationErrorCode = remoteLoginCode.getIn(['data', APPROVE_REMOTE_LOGIN_CODE_ERROR_CODE])
    const successfullyActivatedCode = remoteLoginCode.getIn(['data', REMOTE_LOGIN_CODE_SUCCESSFULLY_ACTIVATED])
    const processing = remoteLoginCode.getIn([APPROVE_REMOTE_LOGIN_CODE_PROCESSING])
    if (codeFromQuerystring
      && !activationErrorCode
      && !successfullyActivatedCode
      && !processing
      && getAuthIsLoggedIn(auth)
    ) {
      getRemoteLoginCodeApproval({ auth, remoteLoginCode: codeFromQuerystring }).then(() => {})
    }
    const { staticText } = props
    return (
      <div className="activate-remote-login-code">
        <div className="activate-remote-login-code__jumbotron">
          <H1 className="activate-remote-login-code__jumbotron-title">
            {staticText.getIn(['data', 'activateYourDevice'])}
          </H1>
        </div>
        <div className="activate-remote-login-code__content-wrapper">
          <div className="activate-remote-login-code__content">
            {renderContent(
              this.props,
              this.state,
              this.setIsAuthenticationConfirmed,
              this.setIsRemoteLoginCodeInputValid,
            )}
          </div>
        </div>
      </div>
    )
  }
}

ActivateRemoteLoginCodePage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  getRemoteLoginCodeApproval: PropTypes.func.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'activateRemoteLoginCodePage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
      user: state.user,
      remoteLoginCode: state.remoteLoginCode,
      resolver: state.resolver,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        getRemoteLoginCodeApproval: actions.remoteLoginCode.getRemoteLoginCodeApproval,
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
      }
    },
  ),
)(ActivateRemoteLoginCodePage)
